const func = $target => {
    var $heroVideo = $target.find('.banner-hero-video'),
        $mobileVideo = $target.find('.banner-video-mobile');
    
    adjustIframeSize();
    $(window).resize(adjustIframeSize);
    
    function adjustIframeSize() {
        var section = $(".impact-plus-video");
        var iframe = $(".banner-hero-video iframe");

        if (section.length && iframe.length) {
            var sectionHeight = section.outerHeight();
            var sectionWidth = section.outerWidth();
            var windowWidth = $(window).width();
            var iframeWidth, iframeHeight, top;

            if (windowWidth > 2000) {
                iframeWidth = sectionWidth * 0.67;
                iframeHeight = sectionHeight * 1.56;
                top = "60%"
            } else if (windowWidth > 1600) {
                iframeWidth = sectionWidth * 0.7;
                iframeHeight = sectionHeight > 600 ? sectionHeight * 1.35 : sectionHeight * 1.2;
                top = "55%"
            } else if (windowWidth > 1400) {
                iframeWidth = sectionWidth * 0.8;
                iframeHeight = Math.max(sectionHeight * 1.2, iframeWidth * 9 / 16);
                top = "50%"
            } else if (windowWidth >= 996 && windowWidth <= 1400) {
                iframeWidth = sectionWidth * 0.9; 
                iframeHeight = Math.min(sectionHeight * 1.1, iframeWidth * 9 / 16);
                top = "50%"
            } else {
                iframeWidth = sectionWidth * 0.9;
                iframeHeight = iframeWidth * 9 / 16;
                top = "50%"
            }

            iframe.css({
                "height": iframeHeight + "px",
                "width": iframeWidth + "px",
                "position": "absolute",
                "top": top,
                "left": "50%",
                "transform": "translate(-50%, -50%)",
                "object-fit": "cover"
            });
        }
    }

    var $videoModal = $target.find('.modal'),
        $body = $('body'),
        $iframe = $videoModal.find('iframe'),
        src = $iframe.attr('src'),
        $video = $videoModal.find('video');

    $('.for-mobile').on('click', function () {
        var $iframe = $(this).parent().find('iframe'),
            $video = $(this).parent().find('video');
        if ($iframe.length > 0) {
            $(this).remove()
            var $newSrc = $iframe.attr('src').replace('controls=0','controls=1');
            $iframe.attr('src',$newSrc+'&autoplay=1')
        } else {
            $video.trigger('play').attr('controls', true);
        }
    })

    $mobileVideo.find('video').removeAttr('controls')
    $heroVideo.find('video').removeAttr('controls').trigger('play').attr('loop', 'loop').prop('muted', true);

    $videoModal
        .on('show.bs.modal', function (e) {
            $body.addClass('modal-backdrop-media');
            if ($iframe.length > 0) {
                if (src.indexOf('?') == -1) {
                    $iframe.attr('src', src + '?autoplay=1');
                } else {
                    $iframe.attr('src', src + '&autoplay=1');
                }
            } else {
                $video.trigger('play');
            }
        })
        .on('hidden.bs.modal', function (e) {
            $body.removeClass('modal-backdrop-media');
            if ($iframe.length > 0) {
                $iframe.attr('src', '');
            } else {
                $($videoModel).find('video').trigger('pause');
            }
        });

        $(document).ready(function () {
            $('a[href*="#"]').on("click", function (event) {
                const targetId = $(this).attr("href").split("#")[1];
                if (targetId) {
                    event.preventDefault();
                    const $targetElement = $("#" + targetId);
        
                    if ($targetElement.length) {
                        $targetElement[0].scrollIntoView({ behavior: "auto", block: "start" });
                    }
                }
            });
        });
        
};

export default func;